import { STATUSPAGE } from '@repo/ui';
import { GetAcademicOverviewData } from 'domain/usecases';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import {
  loadFilters,
  loadData,
} from 'presentation/config/store/reports/academic-overview-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { IAcademicOverviewFilters } from '../models/academic-overview-filters';

interface IProps {
  getAcademicOverviewData: GetAcademicOverviewData;
}

export const useAcademicOverview = ({ getAcademicOverviewData }: IProps) => {
  const [statusGet, setStatusGet] = useState<STATUSPAGE>();

  const dispatch = useDispatch();

  // States
  const { data } = useAppSelector((state) => state.academicOverview);
  const { filters } = useAppSelector((state) => state.academicOverview);

  // Methods
  const requestGetAcademicOverviewData = useCallback(
    async (params?: GetAcademicOverviewData.Params) => {
      setStatusGet(STATUSPAGE.LOADING);

      await getAcademicOverviewData
        .execute(params)
        .then((res) => dispatch(loadData(res)))
        .catch((err) => console.log(err))
        .finally(() => {
          setStatusGet(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const saveFilters = useCallback((params: IAcademicOverviewFilters) => {
    dispatch(loadFilters(params));
  }, []);

  return {
    data,
    filters,
    statusGet,
    saveFilters,
    requestGetAcademicOverviewData,
  };
};
